import React from "react";
import { currentTextCount } from "../utils/cardBodyUiHelpers.js";

/**
 * ProjectNameDisplay Component
 * Reusable component for displaying project name with sprint and client
 */
const ProjectNameDisplay = ({
  projectName,
  sprintName,
  clientName,
  projectId,
  className = "",
  style = {},
  showHiddenInput = true,
}) => {
  const textCount = currentTextCount(projectName, sprintName, clientName);
  const sizeClass = textCount < 21 ? "small" : "large";

  return (
    <>
      <span className={`tooltip-tracker ${sizeClass} ${className}`}>
        {projectName}
        {sprintName && ` - ${sprintName}`}
        {showHiddenInput && <input type="hidden" name="project" value={projectId || ""} />}
        {clientName && <div className="project-name-tracker">{clientName}</div>}
      </span>
      <span
        className={`project-tracker-inner ${sizeClass} ${className}`}
        style={{
          display: "inline-block",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          height: "22px",
          ...style,
        }}
      >
        {projectName}
        {sprintName && ` - ${sprintName}`}
        {showHiddenInput && <input type="hidden" name="project" value={projectId || ""} />}
        {clientName && <div className="project-name-tracker">{clientName}</div>}
      </span>
    </>
  );
};

export default ProjectNameDisplay;
